// extracted by mini-css-extract-plugin
export default {"loaderSection":"loaderWhite_loaderSection__l0c4k","loaderSecitionh1":"loaderWhite_loaderSecitionh1__Rg7Ib","lds_ring":"loaderWhite_lds_ring__u-q8y"};